import {ChangeEvent, FC} from "react";
import styled from "styled-components";
import {MenuItem} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getAchievementsGames} from "modules/selectors";
import {Input} from "components";

const Wrapper = styled.div`
	padding: 20px 16px;

	@media (min-width: 769px) {
		display: none;
	}
`;

interface IBadgesFilter {
	value: string | 0;
	changeHandler: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const BadgesFilter: FC<IBadgesFilter> = ({changeHandler, value}) => {
	const {t} = useTranslation();
	const games = useSelector(getAchievementsGames);

	return (
		<Wrapper>
			<Input
				select
				variant="filled"
				label={t("badges.filter.label")}
				name="game"
				value={value}
				onChange={changeHandler}>
				<MenuItem value={0}>{t("badges.filter.all")}</MenuItem>
				{games.map((game) => (
					<MenuItem value={game} key={game}>
						{t(`badges.filter.${game}`)}
					</MenuItem>
				))}
			</Input>
		</Wrapper>
	);
};
